export default __webpack_public_path__ + "static/media/11-i-am-a-tree.92a64b39.svg";